<template>
  <b-modal @ok='submit' @hidden="reset" @cancel='cancel'  :title="title" class="modal-light" size="lg" v-model="showModal" scrollable>
    <b-row class="mb-3">
      <b-col sm='4'>Name</b-col>
      <b-col sm="8">
        <b-form-input v-model="report.name"></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm='4'>Frequency</b-col>
      <b-col sm="8">
        <v-select v-model="report.frequency" :options="frequencyOptions" class='select-no-caret'/>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col sm='4'>Date Range</b-col>
      <b-col sm="8">
        <v-select v-model="report.date_range" :options="dateRangeOptions" class='select-no-caret'/>
      </b-col>
    </b-row>
    <br>
    <b-row v-if="report.frequency != 'day'">
      <b-col sm='4'>Day</b-col>
      <b-col sm="8">
        <input v-if="report.frequency === 'day'" type='number' placeholder='Day' v-model='report.day'>
        <v-select v-if="report.frequency === 'week'" :value="weekDay" :options="weekDaysOptions" @input="setSelected" class='select-no-caret'/>
        <datepicker v-if="report.frequency === 'month'" :value="monthDay" placeholder="Select Date" @input="setMonthDay"></datepicker>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col sm='4'>Recipients</b-col>
      <b-col sm="8">
        <b-row v-for="(recipient, index) in report.send_to" :key=index>
          <b-col sm="12">
            <span>{{recipient}} &nbsp;</span>
            <button @click="deleteRecipient(recipient)" class="btn btn-secondary xbtn">X</button>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col sm="12">
            <b-form-input v-model="newRecipient"></b-form-input>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col sm="12">
            <button @click="addRecipient" class="btn btn-primary">
              Add Recipient
            </button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br>
    <client-select v-model='report.client'/>
    <br>
    <dashboard-select v-model='report.dashboard' />
  </b-modal>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import vSelect from 'vue-select'
  import ShareSelect from '@/views/base/ShareSelect'
  import ClientSelect from '@/views/base/ClientSelect'
  import DashboardSelect from '@/views/base/DashboardSelect'
  import Datepicker from 'vuejs-datepicker'
  import moment from 'moment'
  export default {
    name: 'ReportFormModal',
    components: {
      ShareSelect,
      ClientSelect,
      DashboardSelect,
      vSelect,
      Datepicker
    },

    data () {
      return {
        title: null,
        showModal: false,
        mode: '',
        newRecipient: null,
        report: {
          client: {},
          send_to: []
        }
      }
    },

    methods: {
      ...mapActions(['createReport', 'submitUpdateReport']),
      ...mapMutations(['setCurrentReport', 'updateReportProperties']),
      setSelected(value) {
       this.report.day = value.value
      },

      setMonthDay (value) {
        this.report.day = moment(value).date()
      },

      addRecipient () {
        if (this.newRecipient !== null) {
          this.report.send_to.push(this.newRecipient)
        }
        this.newRecipient = null
      },

      deleteRecipient (recipient) {
        var index = this.report.send_to.indexOf(recipient);
        if (index > -1) {
          this.report.send_to.splice(index, 1);
        }
      },

      submit (e) {
        e.preventDefault()
        if (this.report.id) {
          this.update()
        } else {
          this.create()
        }
      },

      cancel () {
        this.reset()
      },

      reset() {
        this.report = {
          client: {},
          send_to: []
        }
      },

      create () {
        this.showModal = false
        this.createReport(this.params)
      },

      update () {
        this.showModal = false
        this.updateReportProperties(this.params)
        this.submitUpdateReport()
      },

      initCreateMode () {
        this.reset()
        this.mode = 'create'
        this.showModal = true
        this.title = 'Create Report'
      },

      initEditMode (id) {
        this.reset()
        this.mode = 'edit'
        this.setCurrentReport(id)
        this.report = this.currentReport
        let dash =  this.dashboards.find( dashboard => dashboard.id == this.report.dashboard_id )
        this.report.dashboard = {id: dash.id, name: dash.attributes.name}
        let client =  this.clients.find( client => client.id == this.report.client_id)
        this.report.client = client
        this.showModal = true
        this.title = 'Edit Report'
      }

    },

    computed: {

      ...mapGetters(['currentReport', 'dashboards', 'clients']),

      monthDay () {
        let date = new Date(), y = date.getFullYear(), m = date.getMonth()
        return new Date(y, m, this.report.day)
      },

      weekDay () {
        return this.weekDaysOptions.find( wd => wd.value === this.params.day )
      },

      frequencyOptions () {
        return ['day', 'week', 'month']
      },

      params () {
        return {
          dashboard_id: this.report.dashboard.id,
          client_id: this.report.client.id,
          date_range: this.report.date_range.value,
          frequency: this.report.frequency,
          day: this.report.day,
          send_to: this.report.send_to,
          name: this.report.name
        }
      },

      dateRangeOptions () {
        return [
          { label: 'yesterday', value: '0 day' },
          { label: 'last 7 days' , value: '7 day' },
          { label:'last 30 days' , value: '30 day' },
          { label: 'this month', value: '0 month' },
          { label: 'last month', value: '1 month'},
          { label: 'last 3 months' , value: '3 month' },
          { label: 'last 6 months', value: '6 month' },
          { label: 'last 12 months', value: '12 months' }
        ]
      },

      weekDaysOptions () {
        return [
          { label: 'Sunday', value: 0 },
          { label: 'Monday', value: 1 },
          { label: 'Tuesday', value: 2 },
          { label: 'Wednesday', value: 3 },
          { label: 'Thursday', value: 4 },
          { label: 'Friday', value: 5 },
          { label: 'Saturday', value: 6 },
        ]
      }
    },

    mounted () {
      this.$eventBus.$on('newReportModal', () => this.initCreateMode())
      this.$eventBus.$on('editReportModal', (id) => this.initEditMode(id))
    },

    beforeDestroy(){
      this.$eventBus.$off('editReportModal')
      this.$eventBus.$off('newReportModal')
    },

  }
</script>

<style scoped>
  .xbtn {
    padding: 5px;
    line-height: .75;
  }
  input {
    border: 1px solid rgba(60,60,60,.26);
    color: #333;
  }
</style>
